import Step from "../../components/step/Step";
// import {SuccessStory} from "../../components/success-story/SuccessStory";
// import success1 from "../../assets/step4/success1.jpg";
import {Button} from "@chakra-ui/react";
import {useNavigate} from "react-router-dom";
import {FormattedMessage} from "react-intl";

function Step5() {
    let navigate = useNavigate();
    // const intl = useIntl();

    return (
        <Step currentStep={5}
              backLink={'/step4'}>

            {/* <SuccessStory title={intl.formatMessage({id: 'step5.headline'})} description={intl.formatMessage({id: 'step5.text'})} image={success1}/> */}

            <Button bg="brand"
                    color={'white'}
                    size="md"
                    mt={5} w={'100%'}
                    onClick={() => {
                        navigate('../step6', {replace: true})
                    }}
                    type="submit">
                <FormattedMessage id="form.button.next" />
            </Button>
        </Step>
    );
}

export default Step5;